export default [
    {
        component: () => import(/* webpackChunkName: 'web-service-laboratorio-cliente-laboratorio' */ '@/views/web-service/laboratorio/cliente/laboratorio/Index'),
        path: 'laboratorio-cliente-laboratorio',
        redirect: 'laboratorio-cliente-laboratorio/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'web-service-laboratorio-cliente-laboratorio' */'@/views/web-service/laboratorio/cliente/laboratorio/List.vue'),
                name: 'web-service-laboratorio-cliente-laboratorio-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'web-service-laboratorio-cliente-laboratorio' */ '@/views/web-service/laboratorio/cliente/laboratorio/Form.vue'),
                name: 'web-service-laboratorio-cliente-laboratorio-create',
                path: 'create',
            },
        ],
    },
]